<style>
.test .dropdown-menu {
  transform: translate3d(-4cm, 1cm, -6px) !important;
  left: -45px !important;
}

tbody td {
  font-size: 13px !important;
}

thead th {
  font-size: 13px !important;
}

.badge-yellow {
  background-color: yellow;
}

.blue-row {
  background-color: #d0e7ff;
}

.gap-1 {
  gap: 10px
}

@media (max-width: 647px) {
  .res {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 506px) {
  .resButtons {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .resLead {
    width: 100%;
  }
}

@media (max-width: 400px) {
  .resLines {
    width: 100%;
    float: right;
    display: flex;
    justify-content: flex-end;
  }
}

@media (max-width: 600px) {
  .resButton {
    margin-top: 2px;
  }
}

/* .vs__clear {
  display: none;
} */

/* td ul {
  transform: translate3d(-94px, 19px, 0px) !important;
} */

.example::-webkit-scrollbar {
  display: none !important;
}

/* Freeze the last column (Action) on horizontal scroll */
.table .vgt-responsive table thead th:last-child,
.table .vgt-responsive table tbody td:last-child {
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 2;
}

.table .vgt-responsive table thead th:last-child {
  z-index: 3;
}

.table .vgt-responsive table tbody td:last-child {
  box-shadow: -6px 0 8px -8px rgba(0, 0, 0, 0.25);
}
</style>
<template>
  <div v-if="renderComponent">
    <b-card-code :Addbutton="true" :routerpath="routerpath" :formOptions="formOptions" :visible="visible"
      :selectedID="selectedID" :assignToFormOptions="assignToFormOptions" :getGridData="getGridData">
      <div>
        <b-row>
          <b-col md="12" v-if="title !== 'Legal' && !noAddButton">
            <div class="custom-search d-flex justify-content-between">
              <div>
                <b-button v-if="$route.query.trash" variant="primary" size="sm" class="ml-2 resButton"
                  @click="handleBack">
                  <span class="align-middle">Back</span>
                </b-button>
              </div>
              <b-row>
                <b-form-group :class="plot == true || lead == true || land == true || tour == true || employeeImport == true
                  ? 'resLead'
                  : 'resButtons'
                  ">
                  <div class="d-flex align-items-center">
                    <label class="mr-1">Search</label>
                    <b-form-input @input="advanceGlobleSearch" placeholder="Search" type="text"
                      class="d-inline-block" />
                  </div>
                </b-form-group>

                <b-form-group :class="plot == true || lead == true || land == true || tour == true || employeeImport == true
                  ? 'resLead'
                  : 'resButtons'
                  ">
                  <div class="d-flex align-items-center flex-wrap res w-100 justify-content-end">
                    <b-button v-if="multiplepath" variant="success" size="sm" class="ml-2 resButton"
                      @click="handleClickAddMultiple">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Add Multiple</span>
                    </b-button>

                    <b-button v-if="plot" variant="success" size="sm" class="ml-2 btn-icon" @click="excelClick()">
                      <feather-icon icon="DownloadIcon" />
                    </b-button>

                    <b-button v-if="land" variant="success" size="sm" class="ml-2 btn-icon" @click="excelClick()">
                      <feather-icon icon="DownloadIcon" />
                    </b-button>

                    <b-button v-if="lead" variant="success" size="sm" class="ml-2 btn-icon" @click="excelClick()">
                      <feather-icon icon="DownloadIcon" />
                    </b-button>

                    <b-button v-if="lead" variant="success" size="sm" class="ml-2 resButton" @click="handleClickLead">
                      <div style="display: none">
                        <b-form-file id="fileUploadLead" v-model="leadSheetImport" v-if="lead"
                          @input="handleFileChangeLead($event)" />
                      </div>
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Import Lead</span>
                    </b-button>

                    <!-- <b-button v-if="lead" variant="success" size="sm" class="ml-2 resButton"
                      @click="handleClickTransferLead">
                      <span class="align-middle">Transfer Lead</span>
                    </b-button> -->

                    <b-button
                      v-if="lead && canBulkAssignLeads"
                      variant="primary"
                      size="sm"
                      class="ml-2 resButton"
                      v-b-tooltip.hover
                      title="Assign all selected leads to one employee"
                      @mousedown.stop="captureBulkAssignSelection"
                      @click.stop.prevent="handleClickBulkAssignLead"
                    >
                      <feather-icon icon="UserPlusIcon" class="mr-50" />
                      <span class="align-middle">Bulk assign</span>
                    </b-button>

                    <!-- <b-button
                      v-if="lead"
                      variant="outline-primary"
                      size="sm"
                      class="ml-2 resButton"
                      @click.stop="$router.push('/crm/lead/assign-tracking')"
                    >
                      <feather-icon icon="ListIcon" class="mr-50" />
                      <span class="align-middle">Assign tracking</span>
                    </b-button> -->

                    <b-button v-if="employeeImport && canAddModule" variant="success" size="sm" class="ml-2 btn-icon" @click="excelClick()" v-b-tooltip.hover title="Download import template (CSV)">
                      <feather-icon icon="DownloadIcon" />
                    </b-button>

                    <b-button v-if="employeeImport && canAddModule" variant="success" size="sm" class="ml-2 resButton" @click="handleClickEmployeeImport">
                      <div style="display: none">
                        <b-form-file id="fileUploadEmployee" v-model="employeeSheetImport" accept=".csv,.xlsx,.xls,.txt"
                          @input="handleFileChangeEmployee($event)" />
                      </div>
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Import Employees</span>
                    </b-button>
                    <b-button v-if="title == 'sales'" variant="success" size="sm" class="ml-2 resButton"
                      @click="handleClickTransferLead">
                      <span class="align-middle">Transfer Lead</span>
                    </b-button>
                    <b-button v-if="tour" variant="secondary" size="sm" class="ml-2 resButton"
                      @click="handleClickAddTour">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Add Tour</span>
                    </b-button>
                    <b-button v-if="plot" variant="success" size="sm" class="ml-2 resButton" @click="handleClickPlot">
                      <div style="display: none">
                        <b-form-file id="fileUpload" v-if="plot" @input="handleFileChange($event)" />
                      </div>
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Import Plot</span>
                    </b-button>
                    <b-button v-if="land" variant="success" size="sm" class="ml-2 resButton" @click="handleClickLand">
                      <div style="display: none">
                        <b-form-file id="fileUploadLand" v-if="land" accept=".xlsx,.xls,.csv" @input="handleFileChangeLand($event)" />
                      </div>
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Import</span>
                    </b-button>
                    <b-button v-if="kyc !== true && canAddModule" variant="primary" size="sm" class="ml-2 resButton"
                      @click="handleClickAddbutton">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Add New</span>
                    </b-button>

                    <b-button v-if="bulksales == true" variant="success" size="sm" class="ml-2 resButton"
                      @click="handleClickBulkSales">
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Bulk Add</span>
                    </b-button>
                    <b-button v-if="title == 'Daily Working'" variant="success" size="sm" class="ml-2 resButton"
                      @click="$router.push('/reports/hr/workingreport')">
                      <span class="align-middle">Working Report</span>
                    </b-button>
                    <b-button variant="danger" size="sm" class="ml-1 resButton" id="multidelete"
                      @click="handleMultiDelete" v-if="
                        (userRole == 'admin' || canDeleteModule) &&
                        !noDelete &&
                        title !== 'Legal' &&
                        title !== 'Issue Log' &&
                        title !== 'Modules' &&
                        title !== 'Softwares'
                      ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor"
                        class="bi bi-trash3-fill" viewBox="0 0 16 16">
                        <path
                          d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                      </svg>
                    </b-button>

                    <b-tooltip target="multidelete" triggers="hover">
                      Multi Delete
                    </b-tooltip>
                    <b-button size="sm" variant="success" class="ml-1 resButton" id="restore"
                      @click="handleMultiRestore" v-if="userRole == 'admin' && $route.query.trash">
                      <feather-icon icon="CornerUpLeftIcon" />
                    </b-button>
                    <b-tooltip target="restore" triggers="hover">
                      Multi Restore
                    </b-tooltip>
                    <b-button variant="danger" size="sm" class="ml-1 resButton" id="multidelete"
                      @click="handleTrashRoute" v-if="userRole == 'admin' && !$route.query.trash">
                      <div class="d-flex align-items-center gap-1">
                        <span>Trash</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor"
                          class="bi bi-trash3-fill" viewBox="0 0 16 16">
                          <path
                            d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                        </svg>
                      </div>
                    </b-button>


                    <span class="ml-2 test resLines" v-if="userRole === 'admin' || canExcelModule">
                      <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                        <template v-slot:button-content>
                          <feather-icon width="30" height="30" icon="AlignRightIcon" size="16"
                            class="text-body align-middle mr-25" />
                        </template>
                        <b-dropdown-item @click="downloadExcel('All')" variant="warning" v-if="sheetApi">
                          <b>
                            <feather-icon icon="ArrowDownIcon" class="mr-50" />
                            Download All Data
                          </b>
                        </b-dropdown-item>
                        <b-dropdown-item @click="downloadExcel('')" variant="warning">
                          <b>
                            <feather-icon icon="ArrowDownIcon" class="mr-50" />
                            Download This Page Data
                          </b>
                        </b-dropdown-item>
                        <div class="example" style="
                            width: 6cm;
                            height: 7cm;
                            overflow: hidden scroll;
                            padding: 6px 20px;
                          ">
                          <b-form-group>
                            <label class="h5"> Select Field </label>
                            <b-form-checkbox-group id="checkbox-group-1" v-model="columnFilter" @input="isFilterColumn"
                              :options="columnsData" name="field" class="demo-inline-spacing" />
                          </b-form-group>
                        </div>
                      </b-dropdown>
                    </span>
                    <b-modal id="modal-form" v-model="visible" size="sm" cancel-variant="outline-secondary"
                      ok-title="Submit" cancel-title="Close" :title="showPassword
                        ? 'Change password'
                        : selectedID
                          ? formOptions.formTitle.replace('Add', 'Edit')
                          : formOptions.formTitle
                        " no-close-on-backdrop hide-footer>
                      <Form :popUp="true" :options="formOptions" :handleCloseModel="handleCloseModel"
                        :selectedID="selectedID" :getGridData="getGridData" :edit="edit" :add="add"></Form>
                    </b-modal>
                    <b-modal id="modal-form" v-model="staticPopUp" :title="title" size="sm"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <component :is="popUpCompnent" :closepopup="closepopup" :getGridData="getGridData"
                        :selectedID="selectedID" />
                    </b-modal>
                    <!-- <b-modal id="modal-form" v-model="transferClick" title="Transfer Lead" size="lg"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <TransferLead :closepopup="closepopup" />
                    </b-modal> -->

                    <b-modal
                      id="modal-bulk-assign-leads"
                      v-model="bulkAssignOpen"
                      title="Bulk assign leads"
                      size="md"
                      cancel-variant="outline-secondary"
                      ok-title="Close"
                      cancel-title="Close"
                      no-close-on-backdrop
                      hide-footer
                      @hidden="bulkAssignOpen = false"
                    >
                      <BulkAssignLead
                        v-if="bulkAssignOpen"
                        :selected-leads="bulkAssignLeadRows"
                        :closepopup="closeBulkAssignModal"
                        :get-grid-data="getGridData"
                        :after-assign="clearBulkAssignSelection"
                      />
                    </b-modal>

                    <b-modal id="modal-form-view" v-model="viewPopUp" :title="title" size="lg"
                      cancel-variant="outline-secondary" ok-title="Submit" cancel-title="Close" no-close-on-backdrop
                      hide-footer>
                      <component :is="viewComponent" :closepopup="closepopup" :selectedID="selectedID"
                        v-if="viewComponent" />
                      <viewPage v-else :closepopup="closepopup" :moduleapi="moduleapi" :title="title"
                        :viewFields="viewFields" :getEditValue="formOptions.getEditValue" :selectedID="selectedID">
                        <template #extraView="{ data, item }">
                          <slot name="extraView" :data="data" :item="item"> </slot>
                        </template>
                      </viewPage>
                    </b-modal>
                  </div>
                </b-form-group>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- </div> -->

      <!-- table -->
      <vue-good-table class="table" :row-style-class="useRowColors ? rowClassCallback : null" :columns="columnsItem"
        :rows="rows" :rtl="direction" @on-row-dblclick="handleEdit" :isLoading="loadData" :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: false,
          selectAllByGroup: false,
        }" @on-selected-rows-change="selectionChanged($event)" :line-numbers="true" :search-options="{
          externalQuery: searchTerm,
        }" :pagination-options="paginationOptions">
        <!-- <div slot="table-actions">
        This will show up on the top right of the table.
      </div> -->
        <template slot="column-filter" slot-scope="props">
          <v-select :options="props.column.url ? data[props.column.url] : props.column.options" v-if="
            props.column.url !== 'getUsers' &&
            props.column.type &&
            (props.column.type == 'dropdown' || props.column.type == 'staticdropdown')
          " :label="props.column.responseValue" multiple @input="(valuesArray) =>
            handleCustomFilter(
              valuesArray,
              props.column.field,
              'dropdown',
              props.column.searchField
            )
            ">
            <template #option="item">
              <div v-if="props.column.slotPrams && item[props.column.slotPrams]">
                <span>{{ item[props.column.responseValue] }} ({{ item[props.column.slotPrams] }})</span>
              </div>
            </template>

          </v-select>

          <v-select :options="data[props.column.url]" v-else-if="props.column.url == 'getUsers'"
            style="min-width: 180px" :label="props.column.responseValue" multiple @input="(valuesArray) =>
              handleCustomFilter(
                valuesArray,
                props.column.field,
                'dropdown',
                props.column.searchField
              )
              ">
            <template #option="{ name, profile_image, username, surname }">
              <b-avatar :src="getprofileImage(profile_image)" v-if="name !== 'All'" />
              <span class="font-weight-bolder"> {{ name }} {{ surname }}</span><span v-if="name !== 'All'">({{ username
                }})</span>
            </template>
          </v-select>
          <flat-pickr v-else-if="
            props.column.type == 'datetime' ||
            props.column.field == 'created_date' ||
            props.column.field == 'updated_date'
          " v-model="props.column.value" placeholder="Select Date" class="form-control" :config="{
            mode: 'range',
            enableTime: false,
            dateFormat: 'd/m/Y',
          }" @input="
            handleCustomFilter($event, props.column.field, 'date', props.column.field)
            " style="background: transparent" />
          <b-form-input v-else @input="
            handleCustomFilter(
              $event,
              props.column.field,
              'textbox',
              props.column.searchField
            )
            " placeholder="Search" type="text" class="d-inline-block" />
        </template>
        <template slot="loadingContent">
          <b-spinner variant="primary" label="Text Centered" />
        </template>
        <template slot="table-row" slot-scope="props">
          <slot name="allCustomFields" :props="props" :getGridData="getGridData">
            <div>
              <div v-if="props.column.type === 'image'"
                class="text-nowrap d-flex justify-content-center cursor-pointer">
                <div :id="'image' + props.row.id">
                  <b-avatar :src="getprofileImage(props.row[props.column.field])" />
                </div>
                <b-tooltip v-if="props.row[props.column.field]" :target="'image' + props.row.id" variant="light"
                  triggers="hover">
                  <img :src="getprofileImage(props.row[props.column.field])" alt="" height="100" style="width: 100%" />
                </b-tooltip>
              </div>
              <span v-else-if="props.column.type === 'datetime'">
                {{ setDate(props.row[props.column.field], props.column) }}
              </span>
              <span v-else-if="props.column.field === 'created_date'">
                {{
                  moment(
                    props.row.created_at ? props.row.created_at : props.row.enterdatetime
                  ).format("DD/MM/YYYY h:m A")
                }}
              </span>
              <span v-else-if="props.column.field === 'updated_date'">
                {{
                  moment(
                    props.row.updated_at
                      ? props.row.updated_at
                      : props.row.modifieddatetime
                  ).format("DD/MM/YYYY h:m A")
                }}
              </span>

              <!-- Column: Status -->
              <span v-else-if="props.column.field === 'status' && !changeStatus[props.row.id]" class="cursor-pointer"
                @click="clickStatusChage(props.row, title)">
                <b-badge :variant="statusVariant(props.row.status)">
                  {{ props.row.status }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'approved1'">
                <b-badge :variant="statusVariant(props.row.approved1)">
                  {{ props.row.approved1 ? props.row.approved1 : "Pending" }}
                </b-badge>
              </span>
              <div v-else-if="
                props.column.field === 'status' &&
                title == 'Plot' &&
                changeStatus[props.row.id]
              ">
                <v-select v-model="props.row.status" label="name" style="width: 120px"
                  :options="['Vacant', 'Booked', 'Sold', 'Hold', 'Registered']"
                  @input="handleStatusChage(props.row.status, props.row.id)" />
              </div>

              <!-- Column: Priority -->
              <span v-else-if="props.column.field === 'priority'">
                {{ props.row.priority || props.row.Priority || "" }}
              </span>

              <!-- Column: Remarks -->
              <span v-else-if="props.column.field === 'remarks'">
                {{ props.row.remarks || props.row.Remarks || "" }}
              </span>

              <!-- Column: Action -->
              <span v-else-if="props.column.field === 'action'">
                <div v-if="$route.query.trash" style="width: fit-content; display: flex;gap:10px">
                  <b-badge variant="danger" :id="'delete_permanent' + props.row.id" class="cursor-pointer"
                    @click="handleDelete(props.row)">
                    <feather-icon icon="TrashIcon" />
                  </b-badge>
                  <b-tooltip :target="'delete_permanent' + props.row.id" triggers="hover">
                    Permanent Delete
                  </b-tooltip>
                  <b-badge variant="success" :id="'restore' + props.row.id" class="cursor-pointer"
                    @click="restore([props.row.id])">
                    <feather-icon icon="CornerUpLeftIcon" />
                  </b-badge>
                  <b-tooltip :target="'restore' + props.row.id" triggers="hover">
                    Restore
                  </b-tooltip>
                </div>
                <div v-else style="width: fit-content; display: flex">
                  <slot name="action" :row="props.row" :getGridData="getGridData"></slot>
                  <b-badge v-if="
                    userRole == 'admin' &&
                    !noAction &&
                    (title == 'Employee' ||
                      title == 'Channel Partner' ||
                      title == 'Franchise')
                  " variant="info" :id="'user' + props.row.id" class="mr-50 cursor-pointer"
                    @click="handleUserLogin(props.row)">
                    <feather-icon icon="UserIcon" />
                  </b-badge>
                  <b-tooltip v-if="
                    userRole == 'admin' &&
                    !noAction &&
                    (title == 'Employee' ||
                      title == 'Channel Partner' ||
                      title == 'Franchise')
                  " :target="'user' + props.row.id" triggers="hover">
                    Log in as {{ props.row.name }}
                  </b-tooltip>
                  <b-badge v-if="lead === true" variant="info" :id="'FollowupStatus' + props.row.id" class="mr-50 cursor-pointer"
                    @click="handleFollowupStatus(props.row)">
                    <feather-icon icon="MessageCircleIcon" />
                  </b-badge>
                  <b-tooltip v-if="lead === true" :target="'FollowupStatus' + props.row.id" triggers="hover">
                    Followup
                  </b-tooltip>
                  <b-badge v-if="
                    (userRole == 'admin' || canEditModule) &&
                    !noAction &&
                    title !== 'Issue Log' &&
                    (title != 'Task' ||
                      userRole == 'admin' ||
                      props.row.enterby_data[0].id == userData.id)
                  " variant="warning" :id="'edit' + props.row.id" class="mr-50 cursor-pointer"
                    @click="handleEdit(props.row)">
                    <feather-icon icon="Edit2Icon" />
                  </b-badge>
                  <b-tooltip v-if="
                    (userRole == 'admin' || canEditModule) &&
                    !noAction &&
                    title !== 'Issue Log' &&
                    (title != 'Task' ||
                      userRole == 'admin' ||
                      props.row.enterby_data[0].id == userData.id)
                  " :target="'edit' + props.row.id" triggers="hover">
                    Edit
                  </b-tooltip>
                  <b-badge v-if="title !== 'Issue Log' && !noAction && canViewModule" variant="warning" :id="'view' + props.row.id"
                    class="mr-50 cursor-pointer" @click="handleView(props.row)">
                    <feather-icon icon="EyeIcon" />
                  </b-badge>
                  <b-tooltip v-if="title !== 'Issue Log' && !noAction && canViewModule" :target="'view' + props.row.id" triggers="hover">
                    View
                  </b-tooltip>

                  <b-badge variant="success" :id="'password' + props.row.id" v-if="showPassword"
                    class="mr-50 cursor-pointer" @click="handlePassword(props.row)">
                    <feather-icon icon="LockIcon" />
                  </b-badge>
                  <b-tooltip v-if="showPassword" :target="'password' + props.row.id" triggers="hover">
                    Change password
                  </b-tooltip>
                  <b-badge

                  <b-badge v-if="
                    (userRole == 'admin' || canDeleteModule) &&
                    !noAction &&
                    title != 'Issue Log' &&
                    (title != 'Task' ||
                      userRole == 'admin' ||
                      props.row.enterby_data[0].id == userData.id)
                  " variant="danger" :id="'delete' + props.row.id" class="cursor-pointer"
                    @click="handleDelete(props.row)">
                    <feather-icon icon="TrashIcon" />
                  </b-badge>
                  <b-tooltip v-if="
                    (userRole == 'admin' || canDeleteModule) &&
                    !noAction &&
                    title != 'Issue Log' &&
                    (title != 'Task' ||
                      userRole == 'admin' ||
                      props.row.enterby_data[0].id == userData.id)
                  " :target="'delete' + props.row.id" triggers="hover">
                    Delete
                  </b-tooltip>
                </div>

              </span>

              <!-- Column: Common -->

              <span v-else>
                <slot name="customField" :props="props" :getGridData="getGridData">
                  <span v-if="
                    props.column.type == 'staticdropdown' ||
                    (props.column.url && props.column.type == 'dropdown')
                  ">
                    <div v-if="
                      Array.isArray(props.row[props.column.field]) &&
                      props.row[props.column.field].length > 0
                    ">
                      {{ props.row[props.column.field][0][props.column.responseValue] }}
                    </div>
                    <div v-else-if="typeof props.row[props.column.field] == 'string'">
                      {{ props.row[props.column.field] }}
                    </div>
                    <div v-else-if="props.row[props.column.field]">
                      {{ props.row[props.column.field][props.column.responseValue] }}
                    </div>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </slot>
              </span>
            </div>
          </slot>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <b-form-select v-model="pageLength"
                :options="[
                  { value: 5, text: '5' },
                  { value: 10, text: '10' },
                  { value: 20, text: '20' },
                  { value: 50, text: '50' },
                  { value: 100, text: '100' },
                  { value: 500, text: '500' },
                  { value: 1000, text: '1000' },
                  { value: 5000, text: '5000' },
                  { value: 10000, text: '10000' }
                ]"
                value-field="value"
                text-field="text"
                class="mx-1"
                @input="changePagination()" />
              <span class="text-nowrap">
                Showing {{ paginationStart }} to {{ paginationEnd }} of
                {{ paginationTotal }}</span>
            </div>
            <div>
              <b-pagination v-model="paginationValue" :total-rows="paginationTotal" :per-page="pageLength" first-number
                last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="changePagination('change')">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <div id="element-to-convert" style="display: none">
        <div class="card">
          <div class="card-body mx-4">
            <div class="container">
              <table></table>
            </div>
          </div>
        </div>
      </div>
      <b-modal id="modal-form" v-model="remarksPopUp" cancel-variant="outline-secondary" ok-title="Submit"
        cancel-title="Close" title="Remarks" hide-footer>
        <b-form-textarea v-model="remarksForUpdate" placeholder="Enter Remarks" rows="5" />
        <b-button variant="primary" @click.prevent="submitRemarks($event)" class="mt-2">
          Submit
        </b-button>
      </b-modal>
    </b-card-code>
  </div>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import printComp from "../views/print/printReceipt.vue";
import approvalStatic from "../views/setup/approval/ApprovalStatic.vue";
import reminderStatic from "../views/setup/reminder/ReminderStatic.vue";
import addTemplate from "../views/setup/template/AddTemplate.vue";
import TransferLead from "../views/crm/lead/TransferLead.vue";
import BulkAssignLead from "../views/crm/lead/BulkAssignLead.vue";
import AddRequest from "@/views/hr/hrrequest/AddRequest.vue";
import receiptShow from "../views/accounting/receipt/Show.vue";
import vSelect from "vue-select";
import VueHtml2pdf from "vue-html2pdf";
import moment from "moment";
import jsPDF from "jspdf";
import Form from "@/components/form/Form.vue";
import axios from "@/components/axios";
import viewPage from "@/components/viewPage.vue";
import salesshow from "../views/crm/sales/show.vue";
import siteshow from "../views/crm/sitevisit/Show.vue";
import landshow from "../views/crm/landsales/Show.vue";
import OtherPurchaseShow from "../views/accounting/otherpurchase/Show";
import LeadShow from "../views/crm/lead/Show.vue";
import PlotShow from "../views/master/crm/plot/Show.vue";
import LandPurchase from "../views/accounting/landpurchase/Show.vue";
import LandShowView from "../views/master/crm/land/Show.vue";
import ProjectShow from "../views/master/crm/project/Show.vue";
import flatPickr from "vue-flatpickr-component";
import AddSettings from "@/views/setup/settings/AddSettings.vue";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormSelect,
  BDropdown,
  BCol,
  BRow,
  BButton,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BTooltip,
  BSpinner,
  BFormTextarea,
  BImg,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import html2pdf from "html2pdf.js";
import salesDeed from "./salesDeed";
import * as XLSX from "xlsx";
import { useRoutePermissions } from "@/libs/acl/useRoutePermissions";

// import { codeColumnSearch } from "./code";

export default {
  props: [
    "newPage",
    "moduleapi",
    "title",
    "addTourPath",
    "columns",
    "routerpath",
    "formOptions",
    "assignToFormOptions",
    "paging",
    "addPlot",
    "addLand",
    "multiplepath",
    "approval",
    "reminder",
    "template",
    "lead",
    "employeeImport",
    "add",
    "edit",
    "canDelete",
    "canView",
    "kyc",
    "bulksales",
    "viewFields",
    "popUpCompnent",
    "sheetApi",
    "viewComponent",
    "noAddButton",
    "noDelete",
    "noAction",
    "defaultParams",
    "useRowColors",
  ],
  components: {
    AddSettings,
    AddRequest,
    viewPage,
    salesshow,
    siteshow,
    LeadShow,
    flatPickr,
    addTemplate,
    TransferLead,
    BulkAssignLead,
    reminderStatic,
    landshow,
    LandShowView,
    OtherPurchaseShow,
    approvalStatic,
    BFormTextarea,
    LandPurchase,
    BCardCode,
    BCol,
    BRow,
    html2pdf,
    vSelect,
    BFormFile,
    salesDeed,
    approvalStatic,
    VueGoodTable,
    BSpinner,
    VueHtml2pdf,
    BFormCheckboxGroup,
    printComp,
    BFormCheckbox,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    PlotShow,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    Form,
    BTooltip,
    receiptShow,
    ProjectShow,
    BImg,
  },
  data(props) {
    return {
      props,
      moment,
      imagePath: process.env.VUE_APP_IMAGE_PATH,

      data: [],
      remarksForUpdate: "",
      tableKey: 0,
      paginationValue: 1,
      paginationTotal: 0,
      loadData: false,
      visible: false,
      passwordVisible: false,
      tour: false,
      plot: false,
      land: false,
      plotData: "",
      PassWordField: {
        inputFields: [],
      },
      pageLength: 50,
      _lastPageLength: 50, // Track previous page length to detect changes
      columnFilter: [],
      dir: false,
      showPassword: false,
      CPEditRights: false,
      CPDeleteRights: false,
      receiptData: "",
      paginationStart: 0,
      paginationEnd: 0,
      FranchiseEditRights: false,
      CityOption: [],
      FranchiseDeleteRights: false,
      EditField: {
        inputFields: [],
      },
      pagination: {
        enabled: true,
        mode: "records",
        perPage: 50,
        position: "bottom",
        perPageDropdown: [3, 7, 9],
        dropdownAllowAll: false,
        setCurrentPage: 2,
        jumpFirstOrLast: true,
        firstLabel: "First Page",
        lastLabel: "Last Page",
        nextLabel: "next",
        prevLabel: "prev",
        rowsPerPageLabel: "Rows per page",
        ofLabel: "of",
        pageLabel: "page", // for 'pages' mode
        allLabel: "All",
        infoFn: (params) => `my own page ${params.firstRecordOnPage}`,
      },
      date: "",
      multidelete: false,
      selectedID: 0,
      rowSelection1: [],
      rowSelection: [],
      renderComponent: false,
      baseApi: process.env.VUE_APP_APIENDPOINT,
      webEndpoint: process.env.VUE_APP_WEBENDPOINT,

      accessToken: localStorage.getItem("accessToken"), // JSON.parse()
      users: [],
      rows: [],
      columnsData: [],
      searchTerm: null,
      EDrights: false,
      isFilterSwitch: false,
      approvalPopUp: false,
      reminderPopUp: false,
      templatePopUp: false,
      salesdeedPopup: false,
      // stateOptions: [],
      transferClick: false,
      bulkAssignOpen: false,
      /** Frozen copy of grid selection — vue-good-table clears rowSelection when focus leaves the table (e.g. toolbar click). */
      bulkAssignLeadRows: [],
      /** Lead bulk assign: admin or user id in approval where code is bulkassign (level1). */
      canBulkAssignLeads: false,
      userRole: "",
      // enabledisable: [],
      columnsItem: "",
      projectOptions: [],
      showReceiptsModal: false,
      receipts: [],
      changeStatus: false,
      changeStatus: {},
      selectedPlot: {},
      searchData: {},
      viewPopUp: false,
      remarksPopUp: false,
      KycUserId: "",
      params: {},
      staticPopUp: false,
      leadSheetImport: null,
      employeeSheetImport: null,
      oldStatus: "",
      newStatus: "",
      plotId: "",
    };
  },
  computed: {
    moduleNameForPermissions() {
      return this.title || "";
    },
    permissionHelpers() {
      return useRoutePermissions();
    },
    canAddModule() {
      return this.permissionHelpers.canAdd(this.moduleNameForPermissions);
    },
    canEditModule() {
      return this.permissionHelpers.canEdit(this.moduleNameForPermissions);
    },
    canViewModule() {
      return this.permissionHelpers.canView(this.moduleNameForPermissions);
    },
    canListModule() {
      return this.permissionHelpers.canList(this.moduleNameForPermissions);
    },
    canDeleteModule() {
      return this.permissionHelpers.canDelete(this.moduleNameForPermissions);
    },
    canPdfModule() {
      return this.permissionHelpers.canPdf(this.moduleNameForPermissions);
    },
    canExcelModule() {
      return this.permissionHelpers.canExcel(this.moduleNameForPermissions);
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    setDate() {
      return (date, column) => {
        if (date && moment(date.substring(0, 10), 'DD/MM/YYYY', true).isValid()) {
          return date.substring(0, 10)
        }
        if (date == '0000-00-00') {
          return '-'
        }
        if (
          date &&
          (column.field == "modifieddatetime" ||
            column.field == "enterdatetime" ||
            column.field == "created_at" ||
            column.field == "updated_at" ||
            column.time)
        ) {
          return moment(date).format("DD/MM/YYYY h:m A");
        } else if (date) {
          return moment(date).format("DD/MM/YYYY");
        } else {
          return date;
        }
      };
    },
    paginationOptions() {
      return {
        enabled: true, // Enable pagination to show custom pagination template
        mode: "records", // Use records mode for server-side pagination
        perPage: this.pageLength, // Sync with pageLength
        position: "bottom",
        perPageDropdown: [], // Hide vue-good-table's default dropdown (we use custom)
        dropdownAllowAll: false,
        setCurrentPage: this.paginationValue, // Sync with current page
        firstLabel: "First",
        lastLabel: "Last",
        nextLabel: "next",
        prevLabel: "prev",
        rowsPerPageLabel: "Rows per page",
        ofLabel: "of",
        pageLabel: "page",
        allLabel: "All",
      };
    },
  },
  async mounted() {
    this.userData = JSON.parse(localStorage.getItem("userData"));
    this.userRole = this.userData.role;
    if (this.lead) {
      await this.fetchBulkAssignLeadPermission();
    }
    this.params = {};
    Object.keys(this.$route.query).map((item) => {
      this.params[item] = this.$route.query[item];
    });
    if (this.addTourPath) {
      this.tour = true;
    }
    if (this.addPlot) {
      this.plot = true;
    }
    if (this.addLand) {
      this.land = true;
    }
    this.columnsItem = this.columns;
    this.columnsItem.map((item) => {
      const data = {
        text: item.label,
        value: item,
      };
      this.columnsData.push(data);
    });
    this.columnFilter = this.columnsItem;
    this.columnsItem = this.columnFilter;
    this.forceRerender();
    this.EditField.inputFields = this.formOptions.inputFields;
    this.passwordFieldHandel();
    this.formOptions.inputFields.map((item) => {
      if (item.type == "password") {
        this.showPassword = true;
      }
    });
    this.users = this.$store.state.app.all_users;
    await this.getGridData();
    this.getAllDropdown();
    // this.getState();
    // if (this.title == "Plot") {
    //   this.getProject();
    // }
  },
  watch: {
    '$route'(to, from) {
      // Watch for route changes and reload data with new query parameters
      console.log('Route changed from:', from.query, 'to:', to.query);
      if (JSON.stringify(to.query) !== JSON.stringify(from.query)) {
        this.params = {};
        Object.keys(to.query).map((item) => {
          // Map leadsource parameter to the correct backend parameter name
          if (item === 'leadsource') {
            this.params['leadsource_id'] = to.query[item];
          } else {
            this.params[item] = to.query[item];
          }
        });
        console.log('Updated params:', this.params);
        this.getGridData();
      }
    },
    pageLength(newVal, oldVal) {
      // Ensure pageLength is always a number
      const numVal = parseInt(newVal) || 50;
      if (numVal !== parseInt(oldVal)) {
        this.pageLength = numVal;
        this.pagination.perPage = numVal;
        // Reset to page 1 if current page would be invalid
        const totalPages = Math.ceil(this.paginationTotal / numVal);
        if (this.paginationValue > totalPages && totalPages > 0) {
          this.paginationValue = 1;
        }
      }
    }
  },
  created() {
    // this.$http.get("/good-table/basic").then((res) => {
    //   this.rows = res.data;
    // });
  },
  methods: {
    buildLeadGridRequestParams() {
      const pageSize = parseInt(this.pageLength) || 50;
      let paramsData = {
        pagenum: this.paginationValue,
        ...this.params,
      };
      if (this.defaultParams) {
        paramsData = { ...paramsData, ...this.defaultParams };
      }
      paramsData.pagesize = pageSize;
      for (const key in this.searchData) {
        if (this.searchData[key]) {
          paramsData[key] = this.searchData[key];
        }
      }
      if (this.title === 'Lead') {
        paramsData.include_followups = paramsData.include_followups ?? '0';
      }
      return paramsData;
    },
    rowClassCallback(row) {
      if (row.is_kyc) {
        return "blue-row";
      }
      return "";
    },
    getprofileImage(image) {
      if (image !== undefined && image !== null && image !== "") {
        let test = image.includes(this.imagePath) ? image : this.imagePath + image;
        return test;
      }
      return image;
    },
    handleCustomFilter(e, column, type, searchField) {
      if (type == "textbox") {
        this.searchData[searchField ? searchField : column] = e;
        if (!e) {
          delete this.searchData[searchField ? searchField : column];
        }
      } else if (type == "date") {
        if (e) {
          let dateArr = e.split(" to ");
          dateArr = dateArr.map((item) => {
            return moment(item, "DD/MM/YYYY").format("YYYY-MM-DD");
          });
          this.searchData[searchField ? searchField : column] = dateArr.join("to");
        }
        if (!e) {
          delete this.searchData[searchField ? searchField : column];
        }
      } else {
        let arr = [];
        e.map((item) => {
          arr.push(item.id);
        });
        this.searchData[searchField ? searchField : column] = arr.join(",");
        if (e.length == 0) {
          delete this.searchData[searchField ? searchField : column];
        }
      }
      this.params = [];
      Object.keys(this.$route.query).map((item) => {
        this.params[item] = this.$route.query[item];
      });
      for (let key in this.searchData) {
        this.params[key] = this.searchData[key];
      }
      this.debounceInput();
    },
    debounceInput: _.debounce(function () {
      this.getGridData();
    }, 1000),
    async handleUserLogin(user) {
      await axios({
        method: "POST",
        url: `${this.baseApi}/userLoginById/${user.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      }).then((json) => {
        localStorage.setItem("accessToken", json.data.token);
        localStorage.setItem("userData", JSON.stringify(json.data.user));
        localStorage.setItem("refreshToken", json.data.token);

        this.$router.push("/").then(() => {
          window.location.reload();
        });
      });
    },
    handleMultiMessage() {
      // this.multidelete=true
      this.rowSelection = [];
      this.rowSelection1.map((item) => {
        this.rowSelection.push(item.mobile);
      });
    },
    clickStatusChage(row, title) {
      if (title == "Plot") {
        this.changeStatus[row.id] = true;
        this.oldStatus = row.status;
        this.plotId = row.id;
      }
      this.$forceUpdate();
    },
    handleTrashRoute() {
      const current = window.location.href
      const url = new URL(current);
      url.searchParams.set('trash', 1)
      window.location.href = url.toString()

    },
    async handleStatusChage(status, id) {
      this.newStatus = status;
      if (
        this.oldStatus &&
        (this.oldStatus.toLowerCase() == "booked" ||
          this.oldStatus.toLowerCase() == "sold" ||
          this.oldStatus.toLowerCase() == "registered")
      ) {
        if (status.toLowerCase() == "vacant" || status.toLowerCase() == "hold") {
          this.$swal({
            title: "Are you sure?",
            text: `This plot is already ${this.oldStatus} do you want to change status to ${status}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, update it!",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.handleStatus();
            }
          });
        } else {
          this.handleStatus();
        }
      } else {
        this.handleStatus();
      }
    },
    async submitRemarks() {
      await axios({
        method: "POST",
        url: `${this.baseApi}/plot/change-status`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify({
          id: this.plotId,
          status: this.newStatus,
          remarks: this.remarksForUpdate,
        }),
      }).then((json) => {
        this.remarksPopUp = false;
        this.remarksForUpdate = "";
        this.changeStatus[this.plotId] = false;
        this.getGridData();
        this.$forceUpdate();
      });
    },
    async handleStatus() {
      this.remarksPopUp = true;
    },
    handleFollowupStatus(row) {
      this.$router.push(`/followup/followupinfo?id=${row.id}`);
    },
    handleClickBulkSales() {
      this.$router.push("/crm/multisales/addsales");
    },
    handleMultiDelete() {
      let ids = [];
      this.rowSelection.map((item) => {
        ids.push(item.id);
      });
      if (ids.length == 0) {
        this.$swal({
          icon: "warning",
          title: "Warning",
          text: "Please select atleast one",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
        .then(async (result) => {
          if (result.value) {
            let url = this.$route.query.trash ? `${this.moduleapi}-permanent` : this.moduleapi
            await axios({
              method: "delete",
              url,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.accessToken}`,
              },
              data: JSON.stringify({
                ids,
              }),
            }).then((json) => {
              // Check if deletion failed due to assigned leads
              if (json.data && json.data.success === false) {
                this.$swal({
                  icon: "error",
                  title: "Deletion Failed!",
                  text: json.data.message || "Cannot delete: User has assigned leads.",
                  customClass: {
                    confirmButton: "btn btn-danger",
                  },
                });
                return;
              }
              // this.$router.push(this.options.submitRouterPath);
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: json.data.success || "Your data has been deleted.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getGridData(this.params);
            }).catch((error) => {
              // Handle error response (400 Bad Request with success: false)
              const errorMessage = error.response?.data?.message ||
                                   (error.response?.data?.success === false ? error.response.data.message : null) ||
                                   error.message ||
                                   "An error occurred while deleting.";
              this.$swal({
                icon: "error",
                title: "Error!",
                text: errorMessage,
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            });
          }
        })
        .catch((error) => console.log(error, "error"))
        .finally(() => {
          this.multidelete = false;
        });
    },
    async handleMultiRestore() {
      let ids = [];
      this.rowSelection.map((item) => {
        ids.push(item.id);
      });
      if (ids.length == 0) {
        this.$swal({
          icon: "warning",
          title: "Warning",
          text: "Please select atleast one",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return;
      }
      this.restore(ids)
    },
    selectionChanged(params) {

      // this.multidelete = true;
      this.rowSelection = params.selectedRows;

      // if (params.selectedRows.length == 0) {
      //   this.multidelete = false;
      // }
      // console.log(params.selectedRows.length)
    },
    async downloadExcel(e) {
      // Check Excel permission before allowing download
      if (this.userRole !== 'admin' && !this.canExcelModule) {
        this.$swal({
          icon: 'error',
          title: 'Unauthorized',
          text: 'You do not have permission to download Excel files for this module.',
        });
        return;
      }

      if (e == "All") {
        const gridParams = this.buildLeadGridRequestParams();
        delete gridParams.pagenum;
        delete gridParams.pagesize;
        const exportParams = {
          ...gridParams,
          export_all: '1',
          include_remarks_history: '0',
          include_followups: '0',
        };
        this.$swal({
          title: 'Exporting…',
          text: 'Building Excel file (usually under 30 seconds). Remarks history is skipped for speed.',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        await axios({
          method: "GET",
          url: `${this.baseApi}/${this.sheetApi}`,
          params: exportParams,
          // timeout: 120000,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
        }).then((res) => {
          this.$swal.close();
          const rawUrl = res?.data["export-url"]?.url;
          if (!rawUrl) {
            this.$swal({
              icon: "error",
              title: "Export failed",
              text: "No download URL returned from server.",
            });
            return;
          }
          let fileURL = rawUrl;
          if (
            process.env.VUE_APP_IMAGE_PATH &&
            typeof rawUrl === "string" &&
            rawUrl.includes("/ng-erp/")
          ) {
            const part = rawUrl.split("/ng-erp/")[1];
            if (part) {
              fileURL = process.env.VUE_APP_IMAGE_PATH + part;
            }
          }
          const fURL = document.createElement("a");
          fURL.href = fileURL;
          fURL.setAttribute("download", `Lead.xlsx`);
          document.body.appendChild(fURL);
          document.body.appendChild(fURL);
          fURL.click();
        }).catch((error) => {
          this.$swal.close();
          const msg =
            error.response?.data?.message ||
            error.message ||
            "Excel export failed.";
          this.$swal({
            icon: "error",
            title: "Export failed",
            text: msg,
          });
        });
      } else {
        let data = [];
        this.rows.map((item, index) => {
          data[index] = {};
          this.columnsItem.map((inner) => {
            if (inner.type == "dropdown" || inner.type == "staticdropdown") {
              if (Array.isArray(item[inner.field])) {
                data[index][inner.label] =
                  item[inner.field].length > 0
                    ? item[inner.field][0][inner.responseValue]
                    : "";
              } else if (item[inner.field]) {
                data[index][inner.label] = item[inner.field][inner.responseValue];
              } else {
                data[index][inner.label] = "";
              }
            } else if (inner.field !== "action") {
              // Handle case variations for priority and remarks
              if (inner.field === "priority") {
                data[index][inner.label] = item.priority || item.Priority || null;
              } else if (inner.field === "remarks") {
                data[index][inner.label] = item.remarks || item.Remarks || null;
              } else {
                data[index][inner.label] = item[inner.field];
              }
            }
          });

          // Add Remarks History column for Lead module
          if (this.title === "Lead" && item.followUpData && item.followUpData.length > 0) {
            const remarksHistory = [];
            const allUsers = this.$store.state.app.all_users || [];

            // Sort followups by date (most recent first)
            const sortedFollowups = [...item.followUpData].sort((a, b) => {
              return new Date(b.datetime) - new Date(a.datetime);
            });

            sortedFollowups.forEach((followup) => {
              if (followup.remarks) {
                // Get user name
                let userName = 'System';
                if (followup.enterby && typeof followup.enterby === 'number') {
                  const user = allUsers.find(u => u.id === followup.enterby);
                  if (user) userName = user.fullname || user.name || '';
                } else if (followup.enterby_data && followup.enterby_data.length > 0) {
                  userName = followup.enterby_data[0].name || followup.enterby_data[0].fullname || 'Unknown';
                }

                const date = followup.datetime || '';
                const priority = followup.priority ? `[${followup.priority}]` : '';
                const followupType = followup.followuptype ? `(${followup.followuptype})` : '';

                remarksHistory.push(`${date} ${priority} ${followupType} - ${userName}: ${followup.remarks}`);
              }
            });

            data[index]["Remarks History"] = remarksHistory.length > 0 ? remarksHistory.join('\n\n') : '';
          } else if (this.title === "Lead") {
            data[index]["Remarks History"] = '';
          }
        });
        data.unshift({});
        const data11 = XLSX.utils.json_to_sheet(data, this.columnsItem);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, data11, "data");

        XLSX.writeFile(wb, `${this.title}.xlsx`);
      }
    },
    formatRemarksHistory(row) {
      if (!row.followUpData || row.followUpData.length === 0) {
        return '';
      }

      const allUsers = this.$store.state.app.all_users || [];
      const remarksHistory = [];

      // Sort followups by date (most recent first)
      const sortedFollowups = [...row.followUpData].sort((a, b) => {
        return new Date(b.datetime) - new Date(a.datetime);
      });

      sortedFollowups.forEach((followup) => {
        if (followup.remarks) {
          // Get user name
          let userName = 'System';
          if (followup.enterby && typeof followup.enterby === 'number') {
            const user = allUsers.find(u => u.id === followup.enterby);
            if (user) userName = user.fullname || user.name || '';
          } else if (followup.enterby_data && followup.enterby_data.length > 0) {
            userName = followup.enterby_data[0].name || followup.enterby_data[0].fullname || 'Unknown';
          }

          const date = followup.datetime || '';
          const priority = followup.priority ? `[${followup.priority}]` : '';
          const followupType = followup.followuptype ? `(${followup.followuptype})` : '';

          remarksHistory.push(`${date} ${priority} ${followupType} - ${userName}: ${followup.remarks}`);
        }
      });

      return remarksHistory.join('\n\n');
    },
    salesDeedClicked(row) {
      this.selectedID = row.id;
      this.salesdeedPopup = true;
      this.selectedPlot = row;
    },
    advanceGlobleSearch(val) {
      this.searchTerm = val;
    },
    clearFilter() {
      this.searchTerm = null;
    },
    async advanceSearch(val, DropDown) {
      this.searchTerm = val;
      if (DropDown == "project") {
        this.searchTerm = val.name;
      }
      if (DropDown == "state") {
        const reportauthority = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/getCityByState`,
          data: {
            State: val,
          },
        };
        await axios(reportauthority)
          .then((response) => {
            this.CityOption = response.data.data;
          })
          .catch((error) => console.log(error, "error"));
      }
    },
    searchFieldWise(field, value) { },
    closepopup() {
      this.staticPopUp = false;
      this.transferClick = false;
      this.salesdeedPopup = false;
      this.viewPopUp = false;
      this.selectedID = null;
      this.remarksForUpdate = null;
      this.getGridData();
    },
    handleClickApproval() {
      this.selectedID = 0;
      this.approvalPopUp = true;
    },
    handleClickReminder() {
      this.selectedID = 0;
      if (this.reminder == true) {
        this.reminderPopUp = true;
      } else if (this.template == true) {
        this.templatePopUp = true;
      }
    },
    isFilterColumn() {
      this.columnsItem = [];
      const data = this.columnFilter;
      this.columnFilter = [];
      data.map((item) => {
        if (item.field !== "action") {
          this.columnFilter.push(item);
        }
      });
      data.map((item) => {
        if (item.field == "action") {
          this.columnFilter.push(item);
        }
      });
      this.columnsItem = this.columnFilter;
    },
    setDropdownValue() {
      //   console.log(this.props._props.formOptions.inputFields, 'test--')
      //   if (this.props.columns) {
      //   }
    },
    passwordFieldHandel() {
      this.formOptions.inputFields.map((item) => {
        // console.log(item.type, "item---");
        if (item.type == "password") {
          this.PassWordField.inputFields.push(item);
        }
      });

      // console.log(this.formOptions.inputFields, "item--");
      // PassWordField.push(formOptions.)
    },
    handleCloseModel() {
      // console.log("first");
      this.visible = false;
    },
    // handleClosePasswordModel() {
    //   this.passwordVisible = false;
    // },
    handleClickAddTour() {
      this.$router.push(`${this.addTourPath}`);
    },
    handleClickAddMultiple() {
      this.$router.push(`${this.multiplepath}`);
    },
    handleClickPlot() {
      document.getElementById("fileUpload").click();
    },
    handleClickLand() {
      document.getElementById("fileUploadLand").click();
    },
    handleClickLead() {
      document.getElementById("fileUploadLead").click();
    },
    handleClickEmployeeImport() {
      document.getElementById("fileUploadEmployee").click();
    },
    downloadEmployeeImportSample() {
      const headerLine = [
        "Name", "Surname", "Father / Husband Name", "Email", "Mobile", "Gender", "Birth Date", "Password", "Joining Date", "Marital Status",
        "Current Address Line 1", "Current Address Line 2", "Current Pin Code", "Current City", "Current Area", "Current Taluka", "Current State",
        "Permanent Address Line 1", "Permanent Address Line 2", "Permanent Pin Code", "Permanent City", "Permanent Area", "Permanent Taluka", "Permanent State",
        "Reporting Authority", "Commission Type", "Salary", "Designation", "Branch", "Work Experience", "Previous Company Name", "Previous Designation", "Previous Salary",
        "Education", "PAN No", "Aadhar No", "Bank", "Bank Branch", "Account No", "IFSC Code",
      ].join(",");
      const sample = [
        "John", "Doe", "Father Name", "john.doe@example.com", "9876543210", "Male", "01/01/1990", "SecurePass123", "01/04/2026", "Unmarried",
        "Address line 1", "Address line 2", "380001", "Ahmedabad", "Area", "Taluka", "Gujarat",
        "Same as current", "Same as current", "380001", "Ahmedabad", "Area", "Taluka", "Gujarat",
        "Manager Name", "", "25000", "Sales Executive", "Ahmedabad", "2 years", "Old Co", "Executive", "20000",
        "Graduate", "ABCDE1234F", "123456789012", "HDFC", "Branch Name", "1234567890", "HDFC0001234",
      ].join(",");
      const blob = new Blob([`\uFEFF${headerLine}\n${sample}`], { type: "text/csv;charset=utf-8;" });
      this.downloadBlob(blob, "employee_import_template.csv");
    },
    async handleFileChange(e) {
      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const formData = new FormData();
      formData.append("csv", e);
      formData.append("type", "testing");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
        data: formData,
        url: `${baseApi}/plotAttachment`,
      };

      await axios(requestOptions)
        .then((json) => {
          const response = json.data;
          let msg = "";
          let icon = "success";
          let title = "Submitted";

          // Check if there are failures
          const hasFailures = response.failed > 0 || response.validation_failed ||
                            (response.message && response.message.toLowerCase().includes("failure")) ||
                            (response.message && response.message.toLowerCase().includes("failed"));

          if (hasFailures) {
            icon = "warning";
            title = "Import Completed with Failures";
            // Use the actual message from the API, convert newlines to <br/>
            msg = (response.message || "Plot attachment import completed with some failures").replace(/\n/g, '<br/>');

            // Check if errors, error_list, and failed_rows all contain the same content
            const failedRows = response.failed_rows || [];
            const errors = response.errors || [];
            const errorList = response.error_list || [];

            // Helper function to check if arrays are equal
            const arraysEqual = (arr1, arr2) => {
              if (!arr1 || !arr2) return false;
              if (arr1.length !== arr2.length) return false;
              return arr1.every((val, idx) => val === arr2[idx]);
            };

            // Check if all three arrays are the same
            const allArraysSame = arraysEqual(failedRows, errors) &&
                                 arraysEqual(failedRows, errorList) &&
                                 failedRows.length > 0;

            // If all arrays are the same, only show failed_rows
            if (allArraysSame) {
              if (failedRows.length > 0) {
                msg += `<br/><br/><b>Failed Rows:</b><br/>`;
                failedRows.forEach((row, index) => {
                  msg += `${row}`;
                  if (index < failedRows.length - 1) {
                    msg += `<br/>`;
                  }
                });
              }
            } else {
              // Show failed_rows if available
              if (failedRows.length > 0) {
                msg += `<br/><br/><b>Failed Rows:</b><br/>`;
                failedRows.forEach((row, index) => {
                  msg += `${row}`;
                  if (index < failedRows.length - 1) {
                    msg += `<br/>`;
                  }
                });
              }

              // Show errors only if they're different from failed_rows
              if (errors.length > 0 && !arraysEqual(failedRows, errors)) {
                const errorsNotInFailedRows = errors.filter(err =>
                  !failedRows.some(fr => fr === err)
                );
                if (errorsNotInFailedRows.length > 0) {
                  msg += `<br/><br/><b>Errors:</b><br/>`;
                  errorsNotInFailedRows.forEach((error, index) => {
                    msg += `${error}`;
                    if (index < errorsNotInFailedRows.length - 1) {
                      msg += `<br/>`;
                    }
                  });
                }
              }

              // Show error_list only if it's different from both failed_rows and errors
              if (errorList.length > 0 && !arraysEqual(failedRows, errorList) && !arraysEqual(errors, errorList)) {
                const errorListNotShown = errorList.filter(err =>
                  !failedRows.some(fr => fr === err) && !errors.some(er => er === err)
                );
                if (errorListNotShown.length > 0) {
                  msg += `<br/><br/><b>Additional Errors:</b><br/>`;
                  errorListNotShown.forEach((error, index) => {
                    msg += `${error}`;
                    if (index < errorListNotShown.length - 1) {
                      msg += `<br/>`;
                    }
                  });
                }
              }
            }
          } else {
            // All successful
            msg = response.message || "Imported Successfully";
          }

          this.$swal({
            title: title,
            html: msg,
            icon: icon,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          this.getGridData();
        })
        .catch((error) => {
          let errorMessage = "Some error occurred";
          let htmlMessage = "";

          // Extract error message from response
          if (error.response && error.response.data) {
            const responseData = error.response.data;

            // Handle different error response structures
            if (typeof responseData.message === 'string') {
              errorMessage = responseData.message;
              htmlMessage = responseData.message.replace(/\n/g, '<br/>');
            } else if (responseData.message && typeof responseData.message === 'object') {
              // Handle nested validation error structure
              if (responseData.message.original) {
                const original = responseData.message.original;
                let errors = [];

                if (original.email && Array.isArray(original.email)) {
                  errors.push(`Email: ${original.email[0]}`);
                }
                if (original.name && Array.isArray(original.name)) {
                  errors.push(`Name: ${original.name[0]}`);
                }
                if (original.mobile && Array.isArray(original.mobile)) {
                  errors.push(`Mobile: ${original.mobile[0]}`);
                }

                errorMessage = errors.length > 0 ? errors.join('<br/>') : "Validation error occurred.";
                htmlMessage = errorMessage;
              } else {
                errorMessage = "Import validation error occurred.";
                htmlMessage = errorMessage;
              }
            } else if (responseData.error) {
              errorMessage = responseData.error;
              htmlMessage = responseData.error;
            }

            // Check if errors, error_list, and failed_rows all contain the same content
            const failedRows = responseData.failed_rows || [];
            const errors = responseData.errors || [];
            const errorList = responseData.error_list || [];

            // Helper function to check if arrays are equal
            const arraysEqual = (arr1, arr2) => {
              if (!arr1 || !arr2) return false;
              if (arr1.length !== arr2.length) return false;
              return arr1.every((val, idx) => val === arr2[idx]);
            };

            // Check if all three arrays are the same
            const allArraysSame = arraysEqual(failedRows, errors) &&
                                 arraysEqual(failedRows, errorList) &&
                                 failedRows.length > 0;

            htmlMessage = htmlMessage || errorMessage;

            // If all arrays are the same, only show failed_rows
            if (allArraysSame) {
              if (failedRows.length > 0) {
                if (!htmlMessage.includes('Failed Rows:')) {
                  htmlMessage += `<br/><br/><b>Failed Rows:</b><br/>`;
                }
                failedRows.forEach((row, index) => {
                  htmlMessage += `${row}`;
                  if (index < failedRows.length - 1) {
                    htmlMessage += `<br/>`;
                  }
                });
              }
            } else {
              // Show failed_rows if available
              if (failedRows.length > 0) {
                if (!htmlMessage.includes('Failed Rows:')) {
                  htmlMessage += `<br/><br/><b>Failed Rows:</b><br/>`;
                }
                failedRows.forEach((row, index) => {
                  htmlMessage += `${row}`;
                  if (index < failedRows.length - 1) {
                    htmlMessage += `<br/>`;
                  }
                });
              }

              // Show errors only if they're different from failed_rows
              if (errors.length > 0 && !arraysEqual(failedRows, errors)) {
                const errorsNotInFailedRows = errors.filter(err =>
                  !failedRows.some(fr => fr === err)
                );
                if (errorsNotInFailedRows.length > 0) {
                  if (!htmlMessage.includes('Errors:')) {
                    htmlMessage += `<br/><br/><b>Errors:</b><br/>`;
                  }
                  errorsNotInFailedRows.forEach((errorItem, index) => {
                    htmlMessage += `${errorItem}`;
                    if (index < errorsNotInFailedRows.length - 1) {
                      htmlMessage += `<br/>`;
                    }
                  });
                }
              }

              // Show error_list only if it's different from both failed_rows and errors
              if (errorList.length > 0 && !arraysEqual(failedRows, errorList) && !arraysEqual(errors, errorList)) {
                const errorListNotShown = errorList.filter(err =>
                  !failedRows.some(fr => fr === err) && !errors.some(er => er === err)
                );
                if (errorListNotShown.length > 0) {
                  htmlMessage += `<br/><br/><b>Additional Errors:</b><br/>`;
                  errorListNotShown.forEach((errorItem, index) => {
                    htmlMessage += `${errorItem}`;
                    if (index < errorListNotShown.length - 1) {
                      htmlMessage += `<br/>`;
                    }
                  });
                }
              }
            }
          } else if (error.message) {
            errorMessage = error.message;
            htmlMessage = error.message;
          }

          // Determine if it's a validation error
          const isValidationError = error.response && (error.response.status === 400 || error.response.status === 422);

          this.$swal({
            title: isValidationError ? "Import Failed" : "Error !",
            html: htmlMessage || errorMessage,
            icon: isValidationError ? "warning" : "error",
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          console.log(error, "error");
        });
    },
    async handleFileChangeLead(e) {
      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const formData = new FormData();
      formData.append("csv", e);
      formData.append("type", "testing");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
        data: formData,
        url: `${baseApi}/bulklead`,
      };

      await axios(requestOptions)
        .then((json) => {
          const response = json.data;
          let msg = "";
          let icon = "success";
          let title = "Submitted";

          // Check if there are failures
          const hasFailures = response.failed > 0 || (response.message && response.message.toLowerCase().includes("failure"));

          if (hasFailures) {
            icon = "warning";
            title = "Import Completed with Failures";
            // Use the actual message from the API, convert newlines to <br/>
            msg = (response.message || "Lead import completed with some failures").replace(/\n/g, '<br/>');

            // Check if errors, error_list, and failed_rows all contain the same content
            const failedRows = response.failed_rows || [];
            const errors = response.errors || [];
            const errorList = response.error_list || [];

            // Helper function to check if arrays are equal
            const arraysEqual = (arr1, arr2) => {
              if (!arr1 || !arr2) return false;
              if (arr1.length !== arr2.length) return false;
              return arr1.every((val, idx) => val === arr2[idx]);
            };

            // Check if all three arrays are the same
            const allArraysSame = arraysEqual(failedRows, errors) &&
                                 arraysEqual(failedRows, errorList) &&
                                 failedRows.length > 0;

            // Add inserted and failed counts
            if (response.inserted !== undefined || response.failed !== undefined) {
              msg += `<br/><br/><b>Summary:</b><br/>`;
              msg += `Inserted: ${response.inserted || 0}<br/>`;
              msg += `Failed: ${response.failed || 0}`;
            }

            // If all arrays are the same, only show failed_rows
            if (allArraysSame) {
              if (failedRows.length > 0) {
                msg += `<br/><br/><b>Failed Rows:</b><br/>`;
                failedRows.forEach((row, index) => {
                  msg += `${row}`;
                  if (index < failedRows.length - 1) {
                    msg += `<br/>`;
                  }
                });
              }
            } else {
              // Show failed_rows if available
              if (failedRows.length > 0) {
                msg += `<br/><br/><b>Failed Rows:</b><br/>`;
                failedRows.forEach((row, index) => {
                  msg += `${row}`;
                  if (index < failedRows.length - 1) {
                    msg += `<br/>`;
                  }
                });
              }

              // Show errors only if they're different from failed_rows
              if (errors.length > 0 && !arraysEqual(failedRows, errors)) {
                const errorsNotInFailedRows = errors.filter(err =>
                  !failedRows.some(fr => fr === err)
                );
                if (errorsNotInFailedRows.length > 0) {
                  msg += `<br/><br/><b>Errors:</b><br/>`;
                  errorsNotInFailedRows.forEach((error, index) => {
                    msg += `${error}`;
                    if (index < errorsNotInFailedRows.length - 1) {
                      msg += `<br/>`;
                    }
                  });
                }
              }

              // Show error_list only if it's different from both failed_rows and errors
              if (errorList.length > 0 && !arraysEqual(failedRows, errorList) && !arraysEqual(errors, errorList)) {
                const errorListNotShown = errorList.filter(err =>
                  !failedRows.some(fr => fr === err) && !errors.some(er => er === err)
                );
                if (errorListNotShown.length > 0) {
                  msg += `<br/><br/><b>Additional Errors:</b><br/>`;
                  errorListNotShown.forEach((error, index) => {
                    msg += `${error}`;
                    if (index < errorListNotShown.length - 1) {
                      msg += `<br/>`;
                    }
                  });
                }
              }
            }

            // Add duplicate info details
            if (response.duplicate_info) {
              const dupInfo = response.duplicate_info;

              // Existing emails
              if (dupInfo.existing_emails && dupInfo.existing_emails.length > 0) {
                msg += `<br/><br/><b>Existing Emails:</b><br/>`;
                msg += dupInfo.existing_emails.join(", ") + "<br/>";
              }

              // Existing mobiles
              if (dupInfo.existing_mobiles && dupInfo.existing_mobiles.length > 0) {
                msg += `<br/><b>Existing Mobile Numbers:</b><br/>`;
                msg += dupInfo.existing_mobiles.join(", ") + "<br/>";
              }

              // Duplicate leads details
              if (dupInfo.duplicate_leads && dupInfo.duplicate_leads.length > 0) {
                msg += `<br/><b>Duplicate Lead Details:</b><br/>`;
                dupInfo.duplicate_leads.forEach((lead) => {
                  msg += `${lead.message || `${lead.type}: ${lead.value} - ${lead.employee_name}`}<br/>`;
                });
              }
            }
          } else {
            // All successful
            msg = response.message || "Imported Successfully";

            // Add inserted count if available
            if (response.inserted !== undefined) {
              msg += `<br/><br/><b>Inserted: ${response.inserted} lead(s)</b>`;
            }

            // Add existing emails info if available
            let emails = "";
            if (response.existing_emails) {
              emails = [...new Set(response.existing_emails)];
            }
            if (emails.length > 0) {
              msg += `<br/><br/><b>Existing Emails:</b><br/>${emails.join(", ")}`;
            }
          }

          this.$swal({
            title: title,
            html: msg,
            icon: icon,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          this.getGridData();

          // window.location.reload()
        })
        .catch((error) => {
          let errorMessage = "Some error occurred";
          let htmlMessage = "";

          // Extract error message from response
          if (error.response && error.response.data) {
            const responseData = error.response.data;

            // Handle different error response structures
            if (typeof responseData.message === 'string') {
              errorMessage = responseData.message;
              htmlMessage = responseData.message.replace(/\n/g, '<br/>');
            } else if (responseData.message && typeof responseData.message === 'object') {
              // Handle nested validation error structure
              if (responseData.message.original) {
                const original = responseData.message.original;
                let errors = [];

                if (original.email && Array.isArray(original.email)) {
                  errors.push(`Email: ${original.email[0]}`);
                }
                if (original.name && Array.isArray(original.name)) {
                  errors.push(`Name: ${original.name[0]}`);
                }
                if (original.mobile && Array.isArray(original.mobile)) {
                  errors.push(`Mobile: ${original.mobile[0]}`);
                }

                errorMessage = errors.length > 0 ? errors.join('<br/>') : "Validation error occurred.";
                htmlMessage = errorMessage;
              } else {
                errorMessage = "Import validation error occurred.";
                htmlMessage = errorMessage;
              }
            } else if (responseData.error) {
              errorMessage = responseData.error;
              htmlMessage = responseData.error;
            }

            // Check if errors, error_list, and failed_rows all contain the same content
            const failedRows = responseData.failed_rows || [];
            const errors = responseData.errors || [];
            const errorList = responseData.error_list || [];

            // Helper function to check if arrays are equal
            const arraysEqual = (arr1, arr2) => {
              if (!arr1 || !arr2) return false;
              if (arr1.length !== arr2.length) return false;
              return arr1.every((val, idx) => val === arr2[idx]);
            };

            // Check if all three arrays are the same
            const allArraysSame = arraysEqual(failedRows, errors) &&
                                 arraysEqual(failedRows, errorList) &&
                                 failedRows.length > 0;

            htmlMessage = htmlMessage || errorMessage;

            // If all arrays are the same, only show failed_rows
            if (allArraysSame) {
              if (failedRows.length > 0) {
                if (!htmlMessage.includes('Failed Rows:')) {
                  htmlMessage += `<br/><br/><b>Failed Rows:</b><br/>`;
                }
                failedRows.forEach((row, index) => {
                  htmlMessage += `${row}`;
                  if (index < failedRows.length - 1) {
                    htmlMessage += `<br/>`;
                  }
                });
              }
            } else {
              // Show failed_rows if available
              if (failedRows.length > 0) {
                if (!htmlMessage.includes('Failed Rows:')) {
                  htmlMessage += `<br/><br/><b>Failed Rows:</b><br/>`;
                }
                failedRows.forEach((row, index) => {
                  htmlMessage += `${row}`;
                  if (index < failedRows.length - 1) {
                    htmlMessage += `<br/>`;
                  }
                });
              }

              // Show errors only if they're different from failed_rows
              if (errors.length > 0 && !arraysEqual(failedRows, errors)) {
                const errorsNotInFailedRows = errors.filter(err =>
                  !failedRows.some(fr => fr === err)
                );
                if (errorsNotInFailedRows.length > 0) {
                  if (!htmlMessage.includes('Errors:')) {
                    htmlMessage += `<br/><br/><b>Errors:</b><br/>`;
                  }
                  errorsNotInFailedRows.forEach((errorItem, index) => {
                    htmlMessage += `${errorItem}`;
                    if (index < errorsNotInFailedRows.length - 1) {
                      htmlMessage += `<br/>`;
                    }
                  });
                }
              }

              // Show error_list only if it's different from both failed_rows and errors
              if (errorList.length > 0 && !arraysEqual(failedRows, errorList) && !arraysEqual(errors, errorList)) {
                const errorListNotShown = errorList.filter(err =>
                  !failedRows.some(fr => fr === err) && !errors.some(er => er === err)
                );
                if (errorListNotShown.length > 0) {
                  htmlMessage += `<br/><br/><b>Additional Errors:</b><br/>`;
                  errorListNotShown.forEach((errorItem, index) => {
                    htmlMessage += `${errorItem}`;
                    if (index < errorListNotShown.length - 1) {
                      htmlMessage += `<br/>`;
                    }
                  });
                }
              }
            }
          } else if (error.message) {
            errorMessage = error.message;
            htmlMessage = error.message;
          }

          // Determine if it's a duplicate assignment error
          const isDuplicateError = error.response && (error.response.status === 409 || error.response.status === 404);

          this.$swal({
            title: isDuplicateError ? "Duplicate Assignment" : "Error !",
            html: htmlMessage || errorMessage,
            icon: isDuplicateError ? "warning" : "error",
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          console.log(error, "error");
        })
        .finally(() => { });
    },
    async handleFileChangeEmployee(e) {
      if (!e) {
        return;
      }
      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const formData = new FormData();
      formData.append("csv", e);
      try {
        const json = await axios({
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
          data: formData,
          url: `${baseApi}/bulk-import-employees`,
        });
        const response = json.data;
        const inserted = response.inserted || 0;
        const failed = response.failed || 0;
        let msg = (response.message || "Import finished.").replace(/\n/g, "<br/>");
        msg += `<br/><br/><b>Inserted:</b> ${inserted}<br/><b>Failed:</b> ${failed}`;
        if (response.errors && response.errors.length > 0) {
          msg += `<br/><br/><b>Details:</b><br/>${response.errors.join("<br/>")}`;
        }
        const partial = inserted > 0 && failed > 0;
        const allFail = inserted === 0 && failed > 0;
        const title = partial ? "Import completed with failures" : allFail ? "Import failed" : "Import complete";
        const icon = inserted > 0 && !allFail ? (partial ? "warning" : "success") : "warning";
        this.$swal({
          title,
          html: msg,
          icon: allFail ? "error" : icon,
          allowOutsideClick: false,
          allowEscapeKey: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        this.getGridData();
      } catch (error) {
        const rd = error.response && error.response.data;
        let htmlMessage = rd && rd.message ? String(rd.message).replace(/\n/g, "<br/>") : "Import failed.";
        const fr = (rd && rd.failed_rows) || (rd && rd.errors) || [];
        if (Array.isArray(fr) && fr.length > 0) {
          htmlMessage += `<br/><br/><b>Details:</b><br/>${fr.join("<br/>")}`;
        }
        this.$swal({
          title: "Import failed",
          html: htmlMessage,
          icon: "error",
          allowOutsideClick: false,
          allowEscapeKey: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } finally {
        this.employeeSheetImport = null;
      }
    },
    async handleFileChangeLand(e) {
      // Validate file type
      const allowedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'application/vnd.ms-excel',
                            'text/csv'];
      const allowedExtensions = ['.xlsx', '.xls', '.csv'];
      const fileName = e.name || '';
      const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.$swal({
          title: "Invalid File Type",
          text: "Please select a valid Excel file (.xlsx, .xls) or CSV file (.csv)",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      // Validate file size (50MB = 50 * 1024 * 1024 bytes)
      const maxSize = 50 * 1024 * 1024;
      if (e.size > maxSize) {
        this.$swal({
          title: "File Too Large",
          text: "File size must be less than 50MB",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const formData = new FormData();
      formData.append("file", e);

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
        data: formData,
        url: `${baseApi}/landmaster-import`,
      };

      // Show loading indicator
      this.loadData = true;

      await axios(requestOptions)
        .then((response) => {
          const data = response.data;
          let message = data.message || "Village import completed successfully.";
          let htmlMessage = message;

          // Build summary message
          if (data.inserted !== undefined || data.failed !== undefined) {
            const inserted = data.inserted || 0;
            const failed = data.failed || 0;
            htmlMessage = `<b>${message}</b><br/><br/>`;
            htmlMessage += `<b>Summary:</b><br/>`;
            htmlMessage += `✓ Imported: ${inserted} village(s)<br/>`;
            if (failed > 0) {
              htmlMessage += `✗ Failed: ${failed} village(s)<br/>`;
            }
            htmlMessage += `Total Processed: ${data.total_processed || (inserted + failed)}`;
          }

          // Add errors if any
          const errors = data.errors || data.error_list || [];
          if (errors.length > 0) {
            htmlMessage += `<br/><br/><b>Errors:</b><br/>`;
            htmlMessage += `<div style="max-height: 300px; overflow-y: auto; text-align: left; margin-top: 10px;">`;
            errors.forEach((error, index) => {
              htmlMessage += `${index + 1}. ${error}<br/>`;
            });
            htmlMessage += `</div>`;
          }

          const icon = data.success && data.status ? "success" : (data.inserted > 0 ? "warning" : "error");

          this.$swal({
            title: data.success && data.status ? "Import Successful" : (data.inserted > 0 ? "Partial Success" : "Import Failed"),
            html: htmlMessage,
            icon: icon,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
            width: '600px',
          });

          // Refresh grid data if any records were inserted
          if (data.inserted > 0) {
            this.getGridData();
          }
        })
        .catch((error) => {
          let errorMessage = "An error occurred during import. Please check your file and try again.";

          // Extract error message from response
          if (error.response && error.response.data) {
            const responseData = error.response.data;

            if (typeof responseData.message === 'string') {
              errorMessage = responseData.message;
            } else if (responseData.message && typeof responseData.message === 'object') {
              errorMessage = "Validation error occurred. Please check your file format.";
            } else if (responseData.error) {
              errorMessage = responseData.error;
            }

            // Include errors array if available
            const errors = responseData.errors || responseData.error_list || [];
            if (errors.length > 0) {
              errorMessage += "<br/><br/><b>Errors:</b><br/>";
              errorMessage += `<div style="max-height: 200px; overflow-y: auto; text-align: left; margin-top: 10px;">`;
              errors.forEach((error, index) => {
                errorMessage += `${index + 1}. ${error}<br/>`;
              });
              errorMessage += `</div>`;
            }
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.$swal({
            title: "Import Error",
            html: errorMessage,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
            width: '600px',
          });
          console.log(error, "error");
        })
        .finally(() => {
          this.loadData = false;
          // Reset file input
          const fileInput = document.getElementById("fileUploadLand");
          if (fileInput) {
            fileInput.value = '';
          }
        });
    },
    handleClickTransferLead() {
      this.transferClick = true;
    },
    async fetchBulkAssignLeadPermission() {
      if (!this.lead) {
        this.canBulkAssignLeads = false;
        return;
      }
      try {
        const res = await axios({
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/approval/bulk-assign-leads-permission`,
        });
        const payload = res.data && res.data.data;
        this.canBulkAssignLeads = !!(payload && payload.can_bulk_assign_leads);
      } catch (e) {
        this.canBulkAssignLeads = false;
      }
    },
    /** Runs on mousedown (before click/blur) so selection is still in vue-good-table when toolbar is used. */
    captureBulkAssignSelection() {
      if (!this.lead) return;
      const sel = this.rowSelection;
      if (Array.isArray(sel) && sel.length > 0) {
        this.bulkAssignLeadRows = [...sel];
      }
    },
    handleClickBulkAssignLead() {
      const snapshot =
        this.bulkAssignLeadRows.length > 0
          ? [...this.bulkAssignLeadRows]
          : Array.isArray(this.rowSelection)
            ? [...this.rowSelection]
            : [];
      if (snapshot.length === 0) {
        this.$swal({
          title: "No leads selected",
          text: "Use the row checkboxes to select one or more leads, then click Bulk assign.",
          icon: "warning",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }
      this.bulkAssignLeadRows = snapshot;
      this.bulkAssignOpen = true;
    },
    closeBulkAssignModal() {
      this.bulkAssignOpen = false;
      this.bulkAssignLeadRows = [];
    },
    clearBulkAssignSelection() {
      this.rowSelection = [];
      this.bulkAssignLeadRows = [];
    },
    onProgress(event) { },
    hasGenerated() {
      alert("PDF generated successfully!");
    },
    handelShowModal(receipt) {
      this.showReceiptsModal = true;
      this.receipts = receipt.receipt_items;
    },
    handleBack() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search);
      params.delete('trash');
      url.search = params.toString();
      window.location.href = url
    },
    async handelRecieptPDF(id) {
      // Check PDF permission before allowing download
      if (this.userRole !== 'admin' && !this.canPdfModule) {
        this.$swal({
          icon: 'error',
          title: 'Unauthorized',
          text: 'You do not have permission to download PDF files for this module.',
        });
        return;
      }

      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getreceiptById/${id}`,
      };

      await axios(requestOptions)
        .then((json) => {
          this.receiptData = json.data.data[0];
          let year = moment(this.receiptData.created_at).year();
          let id = this.receiptData.id.toString().padStart(5, "0");
          this.receiptData.receiptNo = "NGR-" + year + "-" + id;

          if (this.receiptData && this.receiptData.receipt_items.length > 30) {
            this.$swal({
              title: "Denied",
              text: "Cannot generate receipt which contains more than 30 plot payments",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          } else {
            this.receiptData.paymentDetails = "";
            if (
              parseFloat(this.receiptData?.receipt_items[0]?.remaining) +
              parseFloat(this.receiptData?.receipt_items[0]?.amount) ==
              parseFloat(this.receiptData.receipt_items[0].sales_data.totalpayment)
            ) {
              this.receiptData.paymenttype = this.receiptData?.receipt_items[0].sales_data.paymenttype;
            } else if (
              this.receiptData?.receipt_items[0].sales_data.bookingtype == "EMI"
            ) {
              this.receiptData.paymenttype = "EMI";
            } else {
              this.receiptData.paymenttype = "Part Payment";
            }
            this.$refs.html2Pdf.generatePdf();
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    handleClickAddbutton() {
      if (JSON.stringify(this.formOptions.inputfiels) == "[]") {
        this.formOptions.inputFields = this.editData;
      } else {
        this.formOptions.inputFields = this.EditField.inputFields;
      }

      // this.$eventBus.$emit("onMounted", this.formOptions);
      if (this.newPage == true) {
        this.$router.push(`${this.routerpath}`);
      }
      if (!this.newPage) {
        let countFields = 0;
        this.formOptions.inputFields &&
          this.formOptions.inputFields.map((item) => {
            if (item.type != "hidden") {
              countFields = countFields + 1;
            }
          });
        if (countFields < 10 || this.popUpCompnent) {
          if (this.popUpCompnent) {
            this.staticPopUp = true;
          } else {
            this.visible = true;
          }
        } else {
          this.$router.push(`${this.routerpath}`);
        }
      }

      if (this.userRole !== "admin" && !this.canAddModule) {
        this.visible = false;
      }
      this.forceRerender();
      this.selectedID = 0;
    },
    changePagination(pageChangeType) {
      // Ensure pageLength is a number
      const newPageLength = parseInt(this.pageLength) || 50;
      const oldPageLength = parseInt(this._lastPageLength) || 50;

      // Only reset to page 1 if page length actually changed (not when clicking page numbers)
      if (pageChangeType !== 'change' && newPageLength !== oldPageLength) {
        // Page length changed, reset to page 1
        this.paginationValue = 1;
      }
      // If pageChangeType is 'change', it means user clicked on a page number
      // Don't reset paginationValue - let it use the new value from v-model

      // Store current pageLength for next comparison
      this._lastPageLength = newPageLength;
      this.pageLength = newPageLength;

      for (let key in this.searchData) {
        if (this.searchData[key]) {
          this.params[key] = this.searchData[key];
        }
      }
      this.getGridData();
    },
    refreshGridData() {
      // Reset to page 1 and refresh data (used after form submission)
      this.paginationValue = 1;
      this.getGridData();
    },
    getGridData() {
      this.loadData = true;
      const pageSize = parseInt(this.pageLength) || 50;
      const paramsData = this.buildLeadGridRequestParams();

      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        params: paramsData,
      };
      const queryString = new URLSearchParams(paramsData).toString();
      const url = `${this.moduleapi}?${queryString}`;

      // Store pageSize for use in response handler
      const currentPageSize = pageSize;

      fetch(url, requestOptions)
        .then(async (res) => {
          // Check if response is ok
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }

          // Handle 204 No Content or empty responses
          if (res.status === 204 || res.headers.get('content-length') === '0') {
            return { data: { data: [], total: 0, from: 0, to: 0 } };
          }

          // Check if response has content
          const text = await res.text();
          if (!text || text.trim() === '') {
            // Return empty data structure instead of throwing error
            console.warn('Empty response from server, returning empty data');
            return { data: { data: [], total: 0, from: 0, to: 0 } };
          }

          // Try to parse JSON
          try {
            return JSON.parse(text);
          } catch (e) {
            console.error('Invalid JSON response:', text.substring(0, 200));
            // Return empty data structure instead of throwing error
            return { data: { data: [], total: 0, from: 0, to: 0 } };
          }
        })
        .then(async (json) => {
          this.paginationTotal = json.data.total;
          this.paginationStart = json.data.from;
          this.paginationEnd = json.data.to;

          // Reset to page 1 if current page is beyond available pages and refetch
          const totalPages = Math.ceil(this.paginationTotal / this.pageLength);
          if (this.paginationValue > totalPages && totalPages > 0) {
            this.paginationValue = 1;
            // Refetch with page 1
            paramsData.pagenum = 1;
            const queryStringRetry = new URLSearchParams(paramsData).toString();
            const urlRetry = `${this.moduleapi}?${queryStringRetry}`;
            const retryRes = await fetch(urlRetry, requestOptions);
            if (!retryRes.ok) {
              throw new Error(`HTTP error! status: ${retryRes.status}`);
            }
            if (retryRes.status === 204 || retryRes.headers.get('content-length') === '0') {
              json = { data: { data: [], total: 0, from: 0, to: 0 } };
            } else {
              const text = await retryRes.text();
              if (!text || text.trim() === '') {
                json = { data: { data: [], total: 0, from: 0, to: 0 } };
              } else {
                try {
                  json = JSON.parse(text);
                  this.paginationTotal = json.data.total;
                  this.paginationStart = json.data.from;
                  this.paginationEnd = json.data.to;
                } catch (e) {
                  json = { data: { data: [], total: 0, from: 0, to: 0 } };
                }
              }
            }
          }

          let responseData = [];
          if (json.data) {
            responseData = json.data;
          }
          if (json.data.data) {
            responseData = json.data.data;
          }

          // Client-side filtering fallback if backend filtering doesn't work
          if (responseData.length === 0 && this.params.leadsource_id) {
            console.log('Backend filtering returned empty results, trying client-side filtering...');
            // Fetch all leads without filter and filter client-side
            this.fetchAllLeadsAndFilter();
            return;
          }

          this.rows = responseData;

          if (json.data?.first_page_url?.includes("target")) {
            this.rows = [];
            json.data.data.map((item) => {
              item.targetItem.map((data) => {
                data.enterby = item.enterby;
                data.modifiedby = item.modifiedby;
                const data1 = {
                  updated_at: item.updated_at,
                  created_at: item.created_at,
                  year: item.year,
                  ...data,
                };
                this.rows.push(data1);
              });
            });
          }
          if (this.title == "Customer" || this.title == "Lead") {
            const usersById = new Map(this.users.map((u) => [u.id, u]));
            this.rows.forEach((item) => {
              if (item.leadsource && item.leadsource.length) {
                if (
                  item.leadsource[0].name == "Employee" ||
                  item.leadsource[0].name == "Channel Partner" ||
                  item.leadsource[0].name == "Franchise" ||
                  item.leadsource[0].name == "Self"
                ) {
                  const subUser = usersById.get(item.subsource);
                  if (subUser) {
                    item.subsource = subUser;
                  }
                } else if (item.leadsource[0].name == "Campaign") {
                  item.subsource = item.campaign;
                }
              }
            });
          }
          if (this.title == "Project") {
            this.rows.map((item) => {
              item.assigntoRole = "";
              if (item.assignto.length > 0) {
                this.users.map((innerItem) => {
                  item.assignto.map((assignto) => {
                    if (assignto == innerItem.id) {
                      if (!item.assigntoRole.includes(innerItem.role.slice(1))) {
                        item.assigntoRole += ` ${innerItem.role.charAt(0).toUpperCase() + innerItem.role.slice(1)
                          }`;
                      }
                    }
                  });
                });
              }
            });
          }
          if (this.title == "Plot") {
            this.rows.map((item) => {
              item.assigntoRole = "";
              if (item.project.assignto.length > 0) {
                this.users.map((innerItem) => {
                  item.project.assignto.map((assignto) => {
                    if (assignto == innerItem.id) {
                      if (!item.assigntoRole.includes(innerItem.role.slice(1))) {
                        item.assigntoRole += ` ${innerItem.role.charAt(0).toUpperCase() + innerItem.role.slice(1)
                          }`;
                      }
                    }
                  });
                });
              }
            });
          }
          const usersById = new Map(this.users.map((u) => [u.id, u]));
          const accessToken = localStorage.getItem("accessToken");
          const baseApi = process.env.VUE_APP_APIENDPOINT;
          for (const item of this.columnsItem) {
            if (item.type == "staticdropdown") {
              this.rows.forEach((row) => {
                const user = usersById.get(row[item.field]);
                if (user) {
                  row[item.field] = user;
                }
              });
            }
            if (item.toggle == true) {
              this.rows.forEach((row) => {
                if (row.active == 0) {
                  row.active = "False";
                }
                if (row.active == 1) {
                  row.active = "True";
                }
              });
            }
            if (item.type == "dropdown" && item.url) {
              if (!this.data[item.url]) {
                try {
                  const response = await axios({
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${accessToken}`,
                    },
                    url: `${baseApi}/${item.url}`,
                  });
                  const payload = response.data.data;
                  this.data[item.url] = payload?.data ?? payload ?? response.data;
                } catch (error) {
                  console.log(error, "error");
                }
              }
              const options = this.data[item.url];
              if (options && options.length) {
                const optionsById = new Map(options.map((opt, index) => [opt.id, { opt, index }]));
                this.rows.forEach((row) => {
                  const match = optionsById.get(row[item.field]);
                  if (match) {
                    if (row[item.field] == "srno") {
                      row[item.field] = match.index + 1;
                    } else {
                      row[item.field] = match.opt[item.responseValue];
                    }
                  }
                });
              }
            }
          }
          this.loadData = false;
          this.data["getUsers"] = this.users;
        })
        .catch((error) => {
          console.error('Error in getGridData:', error);
          this.loadData = false;
        });
    },

    // Client-side filtering fallback method
    async fetchAllLeadsAndFilter() {
      try {
        // Fetch all leads without the leadsource filter
        const paramsWithoutFilter = { ...this.params };
        delete paramsWithoutFilter.leadsource_id;

        const queryString = new URLSearchParams({
          pagenum: 1,
          pagesize: 1000, // Get more records for client-side filtering
          ...paramsWithoutFilter
        }).toString();

        const url = `${this.moduleapi}?${queryString}`;
        console.log('Fetching all leads for client-side filtering:', url);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
        });

        const json = await response.json();
        console.log('All leads response:', json);

        if (json.data && json.data.data) {
          // Filter leads by leadsource on client-side
          const filteredLeads = json.data.data.filter(lead => {
            if (lead.leadsource && lead.leadsource.length > 0) {
              return lead.leadsource[0].id == this.params.leadsource_id;
            }
            return false;
          });

          console.log('Client-side filtered leads:', filteredLeads);
          this.rows = filteredLeads;
          this.paginationTotal = filteredLeads.length;
          this.paginationStart = 1;
          this.paginationEnd = filteredLeads.length;
        }
      } catch (error) {
        console.error('Error in client-side filtering:', error);
      } finally {
        this.loadData = false;
      }
    },
    getAllDropdown() {
      // this.columnsDatatest.map(async (item) => {
      //   if (item.type == "staticdropdown") {
      //     this.rows.map((data) => {
      //       this.users.map((data1) => {
      //         if (data[item.field] == data1.id) {
      //           data[item.field] = data1.name;
      //         }
      //       });
      //     });
      //   }
      //   if (item.toggle == true) {
      //     this.rows.map((data) => {
      //       if (data.active == 0) {
      //         data.active = "False";
      //       }
      //       if (data.active == 1) {
      //         data.active = "True";
      //       }
      //     });
      //   }
      //   if (item.type == "dropdown") {
      //     const accessToken = localStorage.getItem("accessToken");
      //     const baseApi = process.env.VUE_APP_APIENDPOINT;
      //     const requestOptionsUsers = {
      //       method: "GET",
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: `Bearer ${accessToken}`,
      //       },
      //       url: `${baseApi}/${item.url}`,
      //     };
      //     await axios(requestOptionsUsers)
      //       .then((response) => {
      //         response.data.data.data
      //           ? // ? (this.data[Array(item.url)] = response.data.data.data)
      //           (this.data[item.url] = response.data.data.data)
      //           : response.data.data
      //             ? (this.data[item.url] = response.data.data)
      //             : (this.data[item.url] = response.data);
      //       })
      //       .catch((error) => console.log(error, "error"));
      //     this.rows.map((data) => {
      //       this.data[item.url] &&
      //         this.data[item.url].map((data1, index) => {
      //           if (data[item.field] == data1.id) {
      //             if (data[item.field] == "srno") {
      //               data[item.field] = index + 1;
      //             }
      //             data[item.field] = data1[item.responseValue];
      //           }
      //         });
      //     });
      //   }
      // });
    },
    async handelMultiple(id) {
      await axios({
        method: "GET",
        url: `${this.baseApi}/gettargetById/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          const data = json.data.data[0];
          this.$router.push(
            data.targetItem
              ? `/crm/editmultipletarget/${data.id}`
              : `/crm/edittarget/${data.id}`
          );
        })
        .catch((error) => console.log(error, "error"));
    },
    handleView(row) {
      const selectedRowId = row && row.row ? row.row.id : row.id;
      if (this.title === "Lead" && selectedRowId) {
        this.$router.push(`/crm/lead/profile/${selectedRowId}`);
        return;
      }
      this.viewPopUp = true;
      this.selectedID = selectedRowId;
    },
    handleEdit(row) {
      if (this.$route.query.trash) return
      row = row.row ? row.row : row;
      if (this.title == "Site Visit" && row.action == 0) {
        this.$swal({
          title: "Cancelled",
          text: "This Site Visit has been cancelled",
          icon: "error",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      if (this.popUpCompnent) {
        this.staticPopUp = true;
        this.getSelectedId(row);
        return;
      }

      if (JSON.stringify(this.formOptions.inputfiels) == "[]") {
        this.formOptions.inputFields = this.editData;
      } else {
        this.formOptions.inputFields = this.EditField.inputFields;
      }
      let countFields = 0;
      this.formOptions.inputFields.map((item) => {
        if (item.type !== "hidden") {
          countFields = countFields + 1;
        }
      });
      const newPath = this.routerpath.replace("add", "edit");
      if (this.multiplepath == "/crm/addmultipletarget") {
        this.handelMultiple(row.id);
        return;
      }
      if (this.newPage == true) {
        this.$router.push(`${newPath}/${row.id}`);
      }
      if (!this.newPage) {
        countFields < 10
          ? (this.handleOpenModel(), this.getSelectedId(row))
          : this.$router.push(`${newPath}/${row.id}`);
      }
      this.forceRerender();
      if (this.edit !== 1 && this.userRole !== "admin") {
        this.visible = false;
      }
    },
    handlePassword(row) {
      this.PassWordField.inputFields = [];
      this.editData = this.formOptions.inputFields;
      this.formOptions.inputFields.map((item) => {
        if (item.type == "password") {
          this.PassWordField.inputFields.push(item);
          item.class = "col-md-12";
        }
      });
      this.formOptions.inputFields = [];
      this.formOptions.inputFields = this.PassWordField.inputFields;
      const newPath = this.routerpath.replace("add", "edit");
      this.handleOpenModel(), this.getSelectedId(row);
      // : this.$router.push(`${newPath}?id=${row.id}`);
      this.forceRerender();
    },
    handleDelete(row) {
      this.formOptions.inputFields = this.EditField.inputFields;
      const ids = [];
      ids.push(row.id);

      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
        .then(async (result) => {
          if (result.value) {
            let url = this.$route.query.trash ? this.moduleapi + '-permanent' : this.moduleapi;
            await axios({
              method: "delete",
              url: url,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.accessToken}`,
              },
              data: JSON.stringify({
                ids,
              }),
            }).then((json) => {
              // Check if deletion failed due to assigned leads
              if (json.data && json.data.success === false) {
                this.$swal({
                  icon: "error",
                  title: "Deletion Failed!",
                  text: json.data.message || "Cannot delete: User has assigned leads.",
                  customClass: {
                    confirmButton: "btn btn-danger",
                  },
                });
                return;
              }
              // this.$router.push(this.options.submitRouterPath);
              this.getGridData();
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: json.data.success || "Your data has been deleted.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            }).catch((error) => {
              // Handle error response (400 Bad Request with success: false)
              const errorMessage = error.response?.data?.message ||
                                   (error.response?.data?.success === false ? error.response.data.message : null) ||
                                   error.message ||
                                   "An error occurred while deleting.";
              this.$swal({
                icon: "error",
                title: "Error!",
                text: errorMessage,
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            })
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async restore(ids) {
      let url = this.moduleapi + '-restore';
      await axios({
        method: "post",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify({
          ids,
        }),
      }).then((json) => {
        this.getGridData();
        this.$swal({
          icon: "success",
          title: "Restored!",
          text: "Your data has been restored.",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      });
    },
    handleOpenModel() {
      this.visible = true;
    },
    // handleOpenPasswordModel() {
    //   this.passwordVisible = true;
    // },
    getSelectedId(row) {
      this.selectedID = row.id;
    },
    async excelClick() {
      if (this.plot == true) {
        await this.downloadSampleFile('plot.xls', 'Sample Plot.xls');
      } else if (this.lead == true) {
        await this.downloadSampleFile('lead.xlsx', 'Sample lead.xlsx');
      } else if (this.employeeImport == true) {
        this.downloadEmployeeImportSample();
      } else if (this.land == true) {
        // Download sample for land/village import
        const accessToken = localStorage.getItem("accessToken");
        const baseApi = process.env.VUE_APP_APIENDPOINT;

        try {
          const response = await axios({
            method: 'GET',
            url: `${baseApi}/landmaster-download-sample`,
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`,
            },
            responseType: 'blob'
          });

          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Sample_Village.xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Error downloading sample file:', error);
          this.$swal({
            title: "Download Error",
            text: "Unable to download sample file. Please contact the administrator.",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
      }
    },

    async downloadSampleFile(fileName, downloadName) {
      try {
        // First try to download from the backend API (if available)
        const apiURL = `${this.baseApi}/download-sample/${fileName}`;
        const response = await axios({
          method: 'GET',
          url: apiURL,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`,
          },
          responseType: 'blob'
        });

        const blob = new Blob([response.data]);
        this.downloadBlob(blob, downloadName);

      } catch (apiError) {
        console.log('API download failed, trying static file:', apiError);

        try {
          // Try static file from public directory (works in development)
          const staticURL = `${window.location.origin}/docs/${fileName}`;
          const response = await fetch(staticURL);

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const blob = await response.blob();
          this.downloadBlob(blob, downloadName);

        } catch (staticError) {
          console.log('Static file download failed, creating sample file:', staticError);

          // Final fallback - create a basic sample file
          this.createSampleFile(fileName, downloadName);
        }
      }
    },

    downloadBlob(blob, downloadName) {
      const url = window.URL.createObjectURL(blob);
      const fURL = document.createElement("a");
      fURL.href = url;
      fURL.setAttribute("download", downloadName);
      document.body.appendChild(fURL);
      fURL.click();

      // Cleanup
      document.body.removeChild(fURL);
      window.URL.revokeObjectURL(url);
    },

    createSampleFile(fileName, downloadName) {
      // Create a basic sample file based on the file type
      let content = '';
      let mimeType = '';

      if (fileName.includes('plot.xls')) {
        // Create a basic Excel file content for plot sample
        content = this.createPlotSampleData();
        mimeType = 'application/vnd.ms-excel';
      } else if (fileName.includes('lead.xlsx')) {
        // Create a basic Excel file content for lead sample
        content = this.createLeadSampleData();
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      }

      if (content) {
        const blob = new Blob([content], { type: mimeType });
        this.downloadBlob(blob, downloadName);
      } else {
        // Show error if we can't create the file
        this.$swal({
          title: "Download Error",
          text: `Unable to download ${downloadName}. Please contact the administrator.`,
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    createPlotSampleData() {
      // Create a simple CSV-like content that can be opened in Excel
      const headers = [
        'Plot No',
        'Project',
        'Plot Area In Sq.Feet',
        'Plot Value',
        'Plot Amount',
        'Extra Amount',
        'Status',
        'Remarks',
        'Customer Name'
      ].join('\t');

      const sampleRow = [
        '1',
        'Sample Project',
        '1200',
        '500000',
        '500000',
        '50000',
        'Vacant',
        'Sample plot',
        'John Doe'
      ].join('\t');

      return headers + '\n' + sampleRow;
    },

    createLeadSampleData() {
      // Create a simple CSV-like content for lead sample
      const headers = [
        'Name',
        'Email',
        'Mobile',
        'Source',
        'Status',
        'Remarks'
      ].join('\t');

      const sampleRow = [
        'John Doe',
        'john@example.com',
        '9876543210',
        'Website',
        'New',
        'Sample lead'
      ].join('\t');

      return headers + '\n' + sampleRow;
    },
    async forceRerender() {
      // Remove MyComponent from the DOM
      this.renderComponent = false;

      // Wait for the change to get flushed to the DOM
      await this.$nextTick();

      // Add the component back in
      this.renderComponent = true;
    },
  },
};
</script>
